<template>
    <div class="filter-template">
        <div class="horizontal-line">
            <div class="no-wrap-items">
                <FieldGroup_input
                    :field-group_class="'field-group_view_calendar field-group_view_table field-group__icon-50 field-group_view_compact'"
                    :id="'login'"
                    :label="''"
                    :error="[]"
                    :placeholder-empty="true"
                    v-model.trim="value"
                    @update:modelValue="(v) => setFilter(v)"
                />
                <button
                    type="button"
                    class="button button_command filter-template__toggle"
                    :class="{'filter-template__toggle_active': toggleActive}"
                    @click="setFilter(value, !toggleActive)"
                    v-if="toggleFilter"
                >
                    <SvgIcon class="icon" :name="toggleFilter.icon" :title="toggleFilter.title"/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import FieldGroup_input from "@/components/_base/FieldGroup_input.vue";

export default {
    name: "TableFilterInput",
    components: {FieldGroup_input},
    props:{
        object: Object,
        modelValue: [Number, String, Array, Object],
        // {icon, title, match: (itemValue) => Boolean}
        toggleFilter: Object,
    },
    data(){
        return{
          value: '',
        }
    },
    computed: {
        toggleActive() {
            return typeof this.object.operator === 'function'
        },
    },
    methods:{
        setFilter(v, toggleActive = this.toggleActive) {
            if (toggleActive) {
                let match = this.toggleFilter.match
                this.object.onChange({
                    operator: (itemValue, text) => match(itemValue) && (itemValue || '').includes(text),
                    field: this.object.field,
                    value: v || '',
                });
                return
            }
            this.object.onChange({
                operator: 'contains',
                field: this.object.field,
                value: v || undefined,
            });
        },
        test(v){
            console.log(v)
        }
    }
}
</script>

<style scoped lang="scss">
.filter-template {
    ::v-deep(.field-group__input) {
        padding-right: 13px !important;
        cursor: auto;
    }
}
/* tables hide `.filter-template .button`, the toggle has to stay visible */
.filter-template .button.filter-template__toggle {
    display: flex;
}
.filter-template .button.filter-template__toggle_active {
    color: #FF5253;
}
</style>